import { ListaPaises } from "./types/listaPaises";
import { fetchWithRetry } from "../client";

export async function fetchListaPaises(): Promise<ListaPaises[]> {
  const res = await fetchWithRetry<{ data: ListaPaises[] }>(
    `/transparencia/meta/paises`,
  );
  return res.data;
}
